import { CreditCard } from 'lucide-react'
import { Card } from '@/components/ui/card'
import { getMetodoPagamentoLabel } from '../constants'

export function PaymentMethodCard({ metodo }: { metodo: string | null | undefined }) {
  const label = getMetodoPagamentoLabel(metodo)
  return (
    <section className="flex flex-col gap-2">
      <h2 className="text-base font-bold text-foreground">Metodo di pagamento</h2>
      <Card className="flex items-start gap-3 p-5">
        <CreditCard className="mt-0.5 h-5 w-5 shrink-0 text-secondary" />
        <p className="text-sm leading-relaxed text-foreground">{label}</p>
      </Card>
    </section>
  )
}
